<template>
    <div>
        <v-card>
            <v-card-title class="teal" dark>REVISI JADWAL</v-card-title>
            <v-card-subtitle class="teal" dark>{{ paketKode }} - {{ paketNama }}</v-card-subtitle>

            <v-data-table :items="listRevisiJadwal" :headers="headers" hide-default-footer :items-per-page="-1">
                <template v-slot:item.mulai="{item}">
                    <v-edit-dialog :return-value.sync="item.mulai" large persistent> 
                        {{ getDateFormattedDatefns(item.mulai) }}
                        <template v-slot:input>
                            <v-datetime-picker label="Tgl Mulai" v-model="item.mulai" :timePickerProps="timePickerProps" />                           
                        </template>
                    </v-edit-dialog>
                </template>

                <template v-slot:item.selesai="{item}">
                    <v-edit-dialog :return-value.sync="item.selesai" large persistent> 
                        {{ getDateFormattedDatefns(item.selesai) }}
                        <template v-slot:input>
                            <v-datetime-picker label="Tgl Selesai" v-model="item.selesai" :timePickerProps="timePickerProps" />                          
                        </template>
                    </v-edit-dialog>
                </template>

                <template v-slot:item.include="{item}">
                    <v-simple-checkbox v-model="item.include"></v-simple-checkbox>
                </template>

                <template v-slot:item.remark="{item}">
                    <v-textarea v-model="item.remark" row-height="3" auto-grow outlined counter="200" />
                </template>
            </v-data-table>
            
            <v-divider />

            <v-card-text>
                <span v-if="errorMessage.show" class="red--text">{{ errorMessage.text }}</span>
            </v-card-text>

            <v-card-actions>
                <v-btn v-if="btnTutup" color="cyan" dark @click="closeRevisiJadwal()">Tutup</v-btn>
                <v-btn v-if="btnSimpan" color="green" dark @click="submitRevisiJadwal()">Simpan</v-btn>
                <v-btn v-if="btnApprove && canApproveRevisiJadwal()" color="green" dark @click="approveRevisiJadwal()">Approve</v-btn>
            </v-card-actions>

        </v-card>

        <!-- Notification -->
        <v-snackbar
                v-model="notification.show"
                :color="notification.color"
                :timeout=3000
                top
        >
            {{ notification.text }}
        </v-snackbar>

        <v-dialog v-model="submitting" persistent max-width="300px">
            <v-card dark>
                <v-card-title>Sedang diproses</v-card-title>
                <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>


<script>
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { format } from 'date-fns'
import { rules } from './../../lib/rules'
import { validateRevisiJadwalLelang } from "./../../lib/tenderLib"


export default {
    props: {
        paketId: {
            type: Number,
            required: true
        },
        paketKode: {
            type: String,
            default: ""
        },
        paketNama: {
            type: String,
            default: ""
        },
        btnTutup: {
            type: Boolean,
            default: true
        },
        btnSimpan: {
            type: Boolean,
            default: true
        },
        btnApprove: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            rules: { required: rules.required },

            headers: [
                { text: "No.", value: "urut", class: "subtitle-2 font-weight-bold", sortable: false, width: "1%" }, 
                { text: "Tahap", value: "tahap", class: "subtitle-2 font-weight-bold", sortable: false, width: "20%" },
                { text: "No. Arsip", value: "noArsip", class: "subtitle-2 font-weight-bold", sortable: false, width: "12%" },
                { text: "Tgl Mulai", value: "mulai", class: "subtitle-2 font-weight-bold", sortable: false, width: "12%" },
                { text: "Tgl Selesai", value: "selesai", class: "subtitle-2 font-weight-bold", sortable: false, width: "12%" },
                { text: "Remark", value: "remark", class: "subtitle-2 font-weight-bold", sortable: false },
                { text: "", value: "include", class: "subtitle-2 font-weight-bold", sortable: false, width: "1%" },
            ], 

            listJadwal: [], // jadwal sebelumnya
            listRevisiJadwal: [], // jadwal revisi
            
            errorMessage: {
                show: false,
                text: ""
            },

            timePickerProps: {
                format: '24hr'
            },

            notification: {
                show: false,
                color: "success",
                text: ""
            },

            submitting: false,
        }
    },

    watch: {
        paketId() {
            this.getData();
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        getData() {
            this.listJadwal = [];
            this.listRevisiJadwal = [];
            
            Promise.all(
                [
                    axios.get(`${apiUrl}/api/rup/jadwal/${this.paketId}`),
                    axios.get(`${apiUrl}/api/rup/jadwal/revisi/${this.paketId}`)
                ]
            ).then( (responses) => {
                console.log("UpdateJadwal:PromiseAll", responses);
                this.listJadwal = responses[0].data;
                const listRevisi = responses[1].data;

                this.listJadwal.forEach(element => {
                    const revisi = listRevisi.find(check => check.urut === element.urut);

                    if (revisi) {
                        this.listRevisiJadwal.push(revisi);
                    }
                    else {
                        this.listRevisiJadwal.push(Object.assign({}, element));
                    }
                });

            })
            .catch( (error) => {
                console.error(error);
            });
        },

        getDateFormattedDatefns(date) {
            // console.log(`tgl yg masuk: ${date}`)
            return date ? format(Date.parse(date), "dd MMM yyyy HH:mm") : ''
        },

        closeRevisiJadwal() {
            this.errorMessage = {
                show: false,
                text: ""
            };

            this.$emit("closed");
        },

        submitRevisiJadwal() {
            this.errorMessage = {
                show: false,
                text: ""
            };

            const errorValidationMessage = validateRevisiJadwalLelang(this.listJadwal, this.listRevisiJadwal);

            if (errorValidationMessage !== "") {
                this.errorMessage = {
                    show: true,
                    text: errorValidationMessage
                };

                this.notification = {
                    show: true,
                    color: "error",
                    text: errorValidationMessage
                };

                return;
            }
            
            console.log("Submit revisi jadwal");
            this.submitting = true;

            const data = {
                userId: this.$store.getters['userInfo'].userId,
                paketPenyediaId: this.paketId,
                listRevisiJadwal: this.listRevisiJadwal
            };

            axios.post(`${apiUrl}/api/rup/jadwal/revisi`, data)
            .then( (response) => {
                this.listRevisiJadwal = response.data;

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Revisi jadwal berhasil disimpan"
                };

                this.$emit("submitted", true);

            }).catch( (error) => {
                console.error(error);

                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal simpan revisi jadwal [${error.message}]`
                };

                this.$emit("submitted", false);

            }).finally( () => {
                this.submitting = false;
            });

        },

        canApproveRevisiJadwal() {
            return this.$store.getters.userRoles === "manajerULP";
        },

        approveRevisiJadwal() {
            this.submitting = true;

            axios.post(`${apiUrl}/api/rup/jadwal/revisi/approve/${this.paketId}`)
            .then( () => {
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Approve revisi jadwal berhasil disimpan"
                };

                this.$emit("submitted", true);

            }).catch( (error) => {
                console.error(error);

                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal approve revisi jadwal [${error.message}]`
                };

                this.$emit("submitted", false);

            }).finally( () => {
                this.submitting = false;
            });
        }
    }
}
</script>


<style scoped>
.v-textarea {
    font-size: 1.0em;
}
</style>
